<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">{{ 'create_new_profile' | localise }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="form-block">
                <form class="pt-3" [formGroup]="loginForm">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'first_name' | localise }}:</label>
                        <input type="text" name="first_name" class="form-control form-control-lg" formControlName="first_name">
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Фамилия:</label>
                        <input type="text" name="last_name" class="form-control form-control-lg" formControlName="last_name">
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'auth_email' | localise }}:</label>
                        <input type="email" name="email" class="form-control form-control-lg" formControlName="email">
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'auth_password' | localise }}:</label>

                        <input type="password" name="password" class="form-control form-control-lg" formControlName="password">
                    </div>
                </form>

                <div class="clear"></div>

                <button type="button" class="btn btn-block btn-success filter-btn"
                        (click)="onCreate()">{{ 'create' | localise }}</button>
            </div>
        </div>
    </ng-container>
</div>
